/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Portfolio-API
 * Date: 8/5/21
 * Copyright All Rights Reserved
 */
import { keyBy } from 'lodash/fp';
import {
  SCENARIO_ID,
  RETURN_PERIOD_ID,
  PERFORMANCE_METRIC_ID,
  CONFIDENCE_LEVEL_ID,
} from 'constants/searchParams';
import { REPAIR_COSTS_ID } from 'constants/performanceMetrics';

export const PROBABALISTIC_ANALYSIS = 'probabilisticAnalyis';
export const SCENARIO_WITH_FULL_UNCERTAINTY = 'scenarioWithFullUncertainty';
export const SCENARIO_FOR_EVENT_SHAKEMAP = 'scenarioForEventShakemap';

export const analysisTypes = [
  {
    id: PROBABALISTIC_ANALYSIS,
    searchParams: [RETURN_PERIOD_ID, PERFORMANCE_METRIC_ID],
    defaultSearchParamValues: {
      [PERFORMANCE_METRIC_ID]: REPAIR_COSTS_ID,
    },
  },
  {
    id: SCENARIO_WITH_FULL_UNCERTAINTY,
    searchParams: [SCENARIO_ID, PERFORMANCE_METRIC_ID, CONFIDENCE_LEVEL_ID],
    defaultSearchParamValues: {
      [PERFORMANCE_METRIC_ID]: REPAIR_COSTS_ID,
      [CONFIDENCE_LEVEL_ID]: 'mean',
    },
  },
];

export const analysisTypesById = keyBy('id', analysisTypes);



// WEBPACK FOOTER //
// ./js/constants/analysisTypes.js